export default function Contact() {
  return (
    <>
      <h1 className="page-header">Contact Us</h1>
      <hr className="section-devider" />
      <form>
        <div className="mb-3">
          <label>Name</label>
          <input className="form-control" placeholder="Your name" />
        </div>
        <div className="mb-3">
          <label>Email</label>
          <input type="email" className="form-control" placeholder="Your email" />
        </div>
        <div className="mb-3">
          <label>Message</label>
          <textarea className="form-control" rows={4}></textarea>
        </div>
        <button className="btn btn-primary">Send Message</button>
      </form>
    </>
  );
}
